import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const PageContainer = ({ children, className = "", sx = {} }) => (
  <Box
    className={className}
    sx={{ maxWidth: 1170, width: "100%", paddingX: 2, marginX: "auto", ...sx }}
  >
    {children}
  </Box>
);

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  sx: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

export default PageContainer;